import axios from '@/core/http'

const fetchYandexTokens = () => {
  return axios.get('recordings/yandex-tokens/').then(res => res.data)
}

export { fetchYandexTokens }
